import { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { apiJson } from '../api/client.js';
import { FormIcon } from '../forms/FormIcon.jsx';
import { FormRenderer, buildSubmissionBody } from '../forms/FormRenderer.jsx';
import '../forms/forms.css';

function parentOrigin() {
  try {
    return document.referrer ? new URL(document.referrer).origin : '';
  } catch {
    return '';
  }
}

export function PublicFormPage() {
  const { key } = useParams();
  const [searchParams] = useSearchParams();
  const embed = searchParams.get('embed') === '1' || window.self !== window.top;
  const [definition, setDefinition] = useState(null);
  const [error, setError] = useState('');
  const rootRef = useRef(null);

  useEffect(() => {
    apiJson(`/api/public/forms/${key}`, { skipAuth: true })
      .then((data) => {
        setDefinition(data.form);
        document.title = data.form.title;
      })
      .catch((e) => setError(e.status === 404 ? 'This form is not available.' : e.message));
  }, [key]);

  useEffect(() => {
    if (!embed || !rootRef.current || typeof ResizeObserver === 'undefined') return undefined;
    const post = () => window.parent?.postMessage({ a360Form: key, height: Math.ceil(rootRef.current.getBoundingClientRect().height) + 8 }, '*');
    const observer = new ResizeObserver(post);
    observer.observe(rootRef.current);
    post();
    return () => observer.disconnect();
  }, [embed, key, definition]);

  const submit = (values, files, hp) =>
    apiJson(`/api/public/forms/${key}/submit`, {
      method: 'POST',
      skipAuth: true,
      body: buildSubmissionBody(values, files, { _hp: hp, embed: embed ? 1 : 0, _origin: embed ? parentOrigin() : '' }),
    });

  return (
    <div className={`fm-public${embed ? ' is-embed' : ''}`}>
      <div className="fm-public-inner" ref={rootRef}>
        {!embed && definition?.organization?.name ? (
          <header className="fm-public-org">
            {definition.organization.logo_url ? <img src={definition.organization.logo_url} alt="" /> : null}
            <span>{definition.organization.name}</span>
          </header>
        ) : null}
        {error ? (
          <div className="fm-card fm-public-msg">
            <FormIcon name="alert" size={28} />
            <p>{error}</p>
          </div>
        ) : null}
        {!definition && !error ? <p className="fm-empty">Loading…</p> : null}
        {definition ? (
          <div className="fm-card fm-public-card">
            <FormRenderer
              definition={definition}
              onSubmit={definition.accepting ? submit : undefined}
              disabled={!definition.accepting}
              notice={!definition.accepting ? <p className="fm-alert fm-alert--warn">This form is no longer accepting responses.</p> : null}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
}
